module.exports = __webpack_public_path__ + "img/Government_Bond_282781.fa133f79.jpg";